import React, { FC, useCallback } from 'react';
import { SidebarItemNext, TextButton } from '@wix/design-system';
import { FormattedMessage } from 'react-intl';
import { bi } from '../../../services/loggers/bi';
import { SparklesSmall } from '../../../components/common/WixIcons';
import { useMMGRSettings } from '../../../utils/hoc/withMMGRSettings';
import { useMediaStudio } from '../../../utils/hooks/useMediaStudio';
import { MediaManagerSDKFolder } from '../../../utils/media-manager-sdk';
import { mediaManagerSideBarClick } from '@wix/bi-logger-media-manager-g6/v2';

export const AIImageCreationSideBarButton: FC<{ targetFolder: MediaManagerSDKFolder }> = ({ targetFolder }) => {
  const { openAIImageCreation } = useMediaStudio();
  const {
    mmgrSettings: { isAITextToImageEnabled, metaSiteToken },
  } = useMMGRSettings();

  const onClick = useCallback(() => {
    openAIImageCreation({ targetFolder });
    bi.logger().report(mediaManagerSideBarClick({ target: 'ai_image_creation' }));
  }, [targetFolder, openAIImageCreation]);

  return (
    isAITextToImageEnabled &&
    metaSiteToken && (
      <SidebarItemNext itemKey="ai-image-creation" onClick={onClick} dataHook="ai-image-creation-sidebar-button">
        <TextButton skin="standard" size="small" suffixIcon={<SparklesSmall />}>
          <FormattedMessage id="categories.ai-image-creation" />
        </TextButton>
      </SidebarItemNext>
    )
  );
};
